import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { PartyPopper, Bot, Download } from "lucide-react";
import { ReceiptView } from "@/components/ReceiptView";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { PLAN_NAMES, formatDate } from "@/lib/constants";

export default function AfterPaymentPage() {
  const { user, refreshMe } = useAuth();
  const [params] = useSearchParams();
  const [receipt, setReceipt] = useState(null);
  useEffect(() => {
    refreshMe();
    api.get("/billing/receipts/mine").then((r) => {
      const id = params.get("receipt");
      setReceipt(r.data.find((x) => x.id === id) || r.data[0] || false);
    }).catch(() => setReceipt(false));
  }, [params, refreshMe]);

  return (
    <div className="max-w-3xl mx-auto">
      <section className="rounded-3xl bg-[#0b2e20] text-white p-8 sm:p-12 grain text-center rise" data-testid="afterpayment-hero">
        <PartyPopper className="h-14 w-14 mx-auto text-amber-400" />
        <h1 className="font-display text-3xl sm:text-5xl font-extrabold mt-4">Поздравляем, {user.username}!</h1>
        <p className="text-white/80 mt-3 text-lg" data-testid="afterpayment-plan">
          {user.plan !== "free" ? `Тариф ${PLAN_NAMES[user.plan]} активирован${user.plan_until ? ` до ${formatDate(user.plan_until)}` : ""}.` : "Спасибо за оплату!"}
        </p>
        <p className="text-white/60 mt-1 text-sm">Теперь вам доступны скачивание файлов и AI-помощник. Удачи на СОР и СОЧ!</p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link to="/ai" className="inline-flex items-center gap-2 h-11 px-6 rounded-full bg-amber-400 text-[#0b2e20] font-bold hover:bg-amber-300" data-testid="afterpayment-ai-link"><Bot className="h-4 w-4" />Открыть AI-помощника</Link>
          <Link to="/" className="inline-flex items-center gap-2 h-11 px-6 rounded-full border-2 border-white/40 font-bold hover:bg-white/10" data-testid="afterpayment-subjects-link"><Download className="h-4 w-4" />К материалам</Link>
        </div>
      </section>
      <h2 className="font-display text-xl font-bold text-[#0b2e20] mt-8 mb-3">Ваш чек</h2>
      {receipt === null && <p className="text-sm text-[#6b8a7b]">Загрузка...</p>}
      {receipt === false && <p className="text-sm text-[#6b8a7b]" data-testid="afterpayment-no-receipt">Чек не найден. Все чеки есть в разделе <Link to="/plans" className="underline">Тарифы</Link>.</p>}
      {receipt && <ReceiptView r={receipt} />}
    </div>
  );
}
